<template>
    <div v-if="isLoaded">
        <div class="content-body" >
            <div class="row match-height">
                <div v-bind:class="{ fullscreen_expand: isFullscreenDownloadFile, 'col-xl-12 col-lg-12 col-md-12 col-sm-12': !isFullscreenDownloadFile }">
                    <div class="card" style="">
                        <div class="card-header">
                            <h4 class="card-title">Dados</h4>
                            <a class="heading-elements-toggle"><i class="fa fa-ellipsis-v font-medium-3"></i></a>
                            <div class="heading-elements">
                                <ul class="list-inline mb-0">
                                    <li><a @click="onEditStatus()" v-b-tooltip title="Opções de e-mail e notificação"><i class="fa fa-envelope"></i></a></li>
                                    <li><a @click="onEditSenha()" v-b-tooltip title="Alterar Senha"><i class="fa fa-key"></i></a></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-bind:class="{ fullscreen_expand: isFullscreenTarefas, 'col-xl-12 col-lg-12 col-md-12 col-sm-12': !isFullscreenTarefas }">
                    <div class="card" style="">
                        <div class="card-header">
                            <h4 class="card-title">Tarefas</h4>
                            <a class="heading-elements-toggle"><i class="fa fa-ellipsis-v font-medium-3"></i></a>
                            <div class="heading-elements">
                                <ul class="list-inline mb-0">
                                    <li><a @click="onVincularTarefa()" v-if="getPermission('usuarioconf.store')" v-b-tooltip title="Nova Tarefa"><i class="ft-user-plus"></i></a></li>
                                    <li><a @click="onFilterResetTarefa()" v-b-tooltip title="Atualizar listagem"><i class="ft-rotate-cw"></i></a></li>
                                    <li><a @click="expandFullscreenTarefa()" v-b-tooltip title="Expande a tela" v-if="!isFullscreenTarefas"><i class="ft-maximize"></i></a></li>
                                    <li><a @click="expandFullscreenTarefa()" v-b-tooltip title="Minimiza a tela" v-if="isFullscreenTarefas"><i class="ft-minimize"></i></a></li>
                                </ul>
                            </div>
                        </div>
                        <div class="card-content">
                            <div class="table-responsive">
                                <div class="loadingDataPosition">
                                    <div class="loadingData" v-if="loadingDataTarefa">
                                        <div class="loadingDataSpinner">
                                            <spinner v-if="loadingDataTarefa" text-fg-color="#ffffff" message="Carregando..."></spinner>
                                        </div>
                                    </div>
                                    <vuetable ref="vuetable"
                                            api-url="/api/usuarioconf/tarefa"
                                            :fields="fieldsTarefa"
                                            :css="css"
                                            :append-params="moreParams"
                                            track-by="tarefa_id"
                                            pagination-path=""
                                            @vuetable:load-error="onError"
                                            @vuetable:pagination-data="onPaginationDataTarefa"
                                            @vuetable:loaded="onLoadedTarefa"
                                          >
                                            <template slot="status" slot-scope="props">
                                                <span class="badge badge-warning" v-if="props.rowData.status.valor==1">{{ props.rowData.status.descr }}</span>
                                                <span class="badge badge-danger" v-if="props.rowData.status.valor==2">{{ props.rowData.status.descr }}</span>
                                                <span class="badge badge-success" v-if="props.rowData.status.valor==3">{{ props.rowData.status.descr }}</span>
                                                <span class="badge badge-primary" v-if="props.rowData.status.valor==4">{{ props.rowData.status.descr }}</span>
                                            </template>
                                            <template slot="tp_tarefa" slot-scope="props">
                                                <span class="badge badge-primary" v-if="props.rowData.tp_tarefa.valor==1">{{ props.rowData.tp_tarefa.descr }}</span>
                                                <span class="badge badge-success" v-if="props.rowData.tp_tarefa.valor==2">{{ props.rowData.tp_tarefa.descr }}</span>
                                            </template>
                                            <template slot="actions" slot-scope="props">
                                              <div class="custom-actions">
                                                  <a @click="updateTarefa(props.rowData)" v-if="getPermission('usuarioconf.update')" v-b-tooltip title="Editar Tarefa"><i class="fa fa-edit"></i></a>
                                                  <a @click="onAlteraStatus(1, props.rowData, true)" v-b-tooltip title="Pendente"><i class="fa fa-hourglass"></i></a>
                                                  <a @click="onAlteraStatus(2, props.rowData, true)" v-b-tooltip title="Cancelar"><i class="fa fa-times"></i></a>
                                                  <a @click="onAlteraStatus(3, props.rowData, true)" v-b-tooltip title="Concluir"><i class="fa fa-check"></i></a>
                                                  <a @click="onAlteraStatus(4, props.rowData, true)" v-b-tooltip title="Em Andamento"><i class="fa fa-upload"></i></a>
                                              </div>
                                            </template>
                                      </vuetable>
                                  </div>
                                  <div class='col-md-12'>
                                      <div class="pull-left pagination-detail">
                                          <vuetable-pagination-info ref="paginationInfoTarefa"
                                                                    :css="css.pagination"
                                                                    info-class="pull-left"
                                          ></vuetable-pagination-info>
                                      </div>
                                      <div class="pull-right m-a-0">
                                          <vuetable-pagination ref="paginationTarefa"
                                                               :css="css.pagination"
                                                               @vuetable-pagination:change-page="onChangePageTarefa"
                                          ></vuetable-pagination>
                                      </div>
                                 </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-bind:class="{ fullscreen_expand: isFullscreenNotificacao, 'col-xl-6 col-lg-6 col-md-6 col-sm-6': !isFullscreenNotificacao }">
                    <div class="card" style="">
                        <div class="card-header">
                            <h4 class="card-title">Notificações</h4>
                            <a class="heading-elements-toggle"><i class="fa fa-ellipsis-v font-medium-3"></i></a>
                            <div class="heading-elements">
                                <ul class="list-inline mb-0">
                                    <li><a @click="onFilterResetNotificacao()" v-b-tooltip title="Atualizar listagem"><i class="ft-rotate-cw"></i></a></li>
                                    <li><a @click="expandFullscreenNotificacao()" v-b-tooltip title="Expande a tela" v-if="!isFullscreenNotificacao"><i class="ft-maximize"></i></a></li>
                                    <li><a @click="expandFullscreenNotificacao()" v-b-tooltip title="Minimiza a tela" v-if="isFullscreenNotificacao"><i class="ft-minimize"></i></a></li>
                                </ul>
                            </div>
                        </div>
                        <div class="card-content">
                            <div class="table-responsive">
                                <div class="loadingDataPosition">
                                    <div class="loadingData" v-if="loadingDataNotificacao">
                                        <div class="loadingDataSpinner">
                                            <spinner v-if="loadingDataNotificacao" text-fg-color="#ffffff" message="Carregando..."></spinner>
                                        </div>
                                    </div>
                                    <vuetable ref="vuetable_notificacao"
                                            api-url="/api/usuarioconf"
                                            :fields="fieldsNotificacao"
                                            :css="css"
                                            :append-params="moreParams"
                                            track-by="notificacao_id"
                                            pagination-path=""
                                            @vuetable:load-error="onError"
                                            @vuetable:pagination-data="onPaginationDataNotificacao"
                                            @vuetable:loaded="onLoadedNotificacao"
                                          >
                                      </vuetable>
                                  </div>
                                  <div class='col-md-12'>
                                      <div class="pull-left pagination-detail">
                                          <vuetable-pagination-info ref="paginationInfoNotificacao"
                                                                    :css="css.pagination"
                                                                    info-class="pull-left"
                                          ></vuetable-pagination-info>
                                      </div>
                                      <div class="pull-right m-a-0">
                                          <vuetable-pagination ref="paginationNotificacao"
                                                               :css="css.pagination"
                                                               @vuetable-pagination:change-page="onChangePageNotificacao"
                                          ></vuetable-pagination>
                                      </div>
                                 </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-bind:class="{ fullscreen_expand: isFullscreenDownloadFile, 'col-xl-6 col-lg-6 col-md-6 col-sm-6': !isFullscreenDownloadFile }">
                    <div class="card" style="">
                        <div class="card-header">
                            <h4 class="card-title">Downloads de Arquivos</h4>
                            <a class="heading-elements-toggle"><i class="fa fa-ellipsis-v font-medium-3"></i></a>
                            <div class="heading-elements">
                                <ul class="list-inline mb-0">
                                    <li><a @click="onFilterResetDownloadFile()" v-b-tooltip title="Atualizar listagem"><i class="ft-rotate-cw"></i></a></li>
                                    <li><a @click="expandFullscreenDownloadFile()" v-b-tooltip title="Expande a tela" v-if="!isFullscreenDownloadFile"><i class="ft-maximize"></i></a></li>
                                    <li><a @click="expandFullscreenDownloadFile()" v-b-tooltip title="Minimiza a tela" v-if="isFullscreenDownloadFile"><i class="ft-minimize"></i></a></li>
                                    <li><a @click="onDownload(null, false)" v-b-tooltip title="Download lote"><i class="ft-download"></i></a></li>
                                </ul>
                            </div>
                        </div>
                        <div class="card-content">
                            <div class="table-responsive">
                                <div class="loadingDataPosition">
                                    <div class="loadingData" v-if="loadingDataDownloadFile">
                                        <div class="loadingDataSpinner">
                                            <spinner v-if="loadingDataDownloadFile" text-fg-color="#ffffff" message="Carregando..."></spinner>
                                        </div>
                                    </div>
                                    <vuetable ref="vuetable_downloadfile"
                                            api-url="/api/usuarioconf/downloadfile"
                                            :fields="fieldsDownloadFile"
                                            :css="css"
                                            :append-params="moreParams"
                                            track-by="dowfil_id"
                                            pagination-path=""
                                            @vuetable:load-error="onError"
                                            @vuetable:pagination-data="onPaginationDataDownloadFile"
                                            @vuetable:loaded="onLoadedDownloadFile"
                                          >
                                          <template slot="actions" slot-scope="props">
                                            <div class="custom-actions">
                                                <a @click="onDownload(props.rowData, true)" v-if="getPermission('usuarioconf.update')" v-b-tooltip title="Download"><i class="fa fa-download"></i></a>
                                            </div>
                                          </template>
                                      </vuetable>
                                  </div>
                                  <div class='col-md-12'>
                                      <div class="pull-left pagination-detail">
                                          <vuetable-pagination-info ref="paginationInfoDownloadFile"
                                                                    :css="css.pagination"
                                                                    info-class="pull-left"
                                          ></vuetable-pagination-info>
                                      </div>
                                      <div class="pull-right m-a-0">
                                          <vuetable-pagination ref="paginationDownloadFile"
                                                               :css="css.pagination"
                                                               @vuetable-pagination:change-page="onChangePageDownloadFile"
                                          ></vuetable-pagination>
                                      </div>
                                 </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
            <!-- Modal Component -->
            <b-modal id="modal_form"
                     ref="modal_form"
                     :title="modal_titulo"
                     :ok-title="modal_botao"
                     close-title="Fechar"
                     cancel-title="Cancelar"
                     :ok-disabled=form_tarefa.errors.any()
                     v-model="showModal"
                     @ok="handleOk">

           <form @submit.stop.prevent="handleOk" @keydown="form_tarefa.errors.clear($event.target.name)">
               <b-col>
                   <label>Título</label>
                   <b-form-input type="text"
                                 placeholder="Título"
                                 v-model="form_tarefa.titulo"
                                 name="titulo">
                   </b-form-input>
                   <b-form-feedback v-text="form_tarefa.errors.get('titulo')" v-if="form_tarefa.errors.has('titulo')"></b-form-feedback>
               <b-col>
               </b-col>
                   <label>Descrição</label>
                   <b-form-input type="text"
                                 placeholder="Descrição"
                                 v-model="form_tarefa.descr"
                                 name="descr">
                   </b-form-input>
                   <b-form-feedback v-text="form_tarefa.errors.get('descr')" v-if="form_tarefa.errors.has('descr')"></b-form-feedback>
               </b-col>
               <b-col  v-if="this.modal_acao == 'u'">
                   <label>Data Cadastro</label>
                   <b-form-input type="text"
                                 placeholder="dd/mm/yyyy"
                                 v-mask="'##/##/####'"
                                 v-model="form_tarefa.dt_cadastro"
                                 name="dt_cadastro">
                   </b-form-input>
                   <b-form-feedback v-text="form_tarefa.errors.get('dt_cadastro')" v-if="form_tarefa.errors.has('dt_cadastro')"></b-form-feedback>
               </b-col>
               <b-col>
                   <label>Data Limite</label>
                   <b-form-input type="text"
                                 placeholder="dd/mm/yyyy"
                                 v-mask="'##/##/####'"
                                 v-model="form_tarefa.dt_tarefa"
                                 name="dt_tarefa">
                   </b-form-input>
                   <b-form-feedback v-text="form_tarefa.errors.get('dt_tarefa')" v-if="form_tarefa.errors.has('dt_tarefa')"></b-form-feedback>
               </b-col>
               <b-col>
                   <label tag="div">Tipo Tarefa</label>
                   <multiselect v-model="form_tarefa.tp_tarefa"
                   :options="optionsTpTarefa"
                   track-by="value"
                   label="label"
                   :hide-selected="true"
                   placeholder="Selecione"
                   tag-placeholder="Selecionar"
                   select-label="Selecionar"
                   selected-label="Selecionado"
                   deselect-label="Remover"
                   ></multiselect>
                   <b-form-feedback v-text="form_tarefa.errors.get('tp_tarefa.value')" v-if="form_tarefa.errors.has('tp_tarefa.value')"></b-form-feedback>
               </b-col>
               <b-col>
                   <label tag="div">Status</label>
                   <multiselect v-model="form_tarefa.status"
                   :options="optionsStatus"
                   track-by="value"
                   label="label"
                   :hide-selected="true"
                   placeholder="Selecione"
                   tag-placeholder="Selecionar"
                   select-label="Selecionar"
                   selected-label="Selecionado"
                   deselect-label="Remover"
                   ></multiselect>
                   <b-form-feedback v-text="form_tarefa.errors.get('status.value')" v-if="form_tarefa.errors.has('status.value')"></b-form-feedback>
               </b-col>
           </form>
                  <div slot="modal-footer" class="w-100">
                         <div class="float-left"><spinner v-if="loading" message="Processando..."></spinner></div>
                         <div class="float-right">
                             <b-btn @click="showModal=false" variant="secondary">
                               Fechar
                             </b-btn>
                             <b-btn @click="handleOk($event)" variant="primary" :disabled="isDisabled">
                               Enviar
                             </b-btn>
                         </div>
                  </div>
              </b-modal>
              <!-- Modal Component -->
              <b-modal id="modal_form_senha"
                       ref="modal_form_senha"
                       :title="modal_titulo"
                       :ok-title="modal_botao"
                       close-title="Fechar"
                       cancel-title="Cancelar"
                       :ok-disabled=form.errors.any()
                       v-model="showModalSenha"
                       @ok="doAlterPassword">

             <form @submit.stop.prevent="doAlterPassword" @keydown="form.errors.clear($event.target.name)">
                <b-col>
                     <label>Senha atual</label>
                     <b-form-input type="password"
                                   placeholder="Senha atual"
                                   v-model="form.senha_atual"
                                   name="senha_atual">
                     </b-form-input>
                     <b-form-feedback class="text-danger" v-text="form.errors.get('senha_atual')" v-if="form.errors.has('senha_atual')"></b-form-feedback>
                </b-col>
                <b-col>
                     <label>Nova Senha</label>
                     <b-form-input type="password"
                                   placeholder="Nova senha"
                                   v-model="form.nova_senha"
                                   name="nova_senha">
                     </b-form-input>
                     <b-form-feedback class="text-danger" v-text="form.errors.get('nova_senha')" v-if="form.errors.has('nova_senha')"></b-form-feedback>
                </b-col>
                <b-col>
                     <label>Confirmar senha</label>
                     <b-form-input type="password"
                                   placeholder="Confirmar senha"
                                   v-model="form.nova_senha_conf"
                                   name="nova_senha_conf">
                     </b-form-input>
                     <b-form-feedback class="text-danger" v-text="form.errors.get('nova_senha_conf')" v-if="form.errors.has('nova_senha_conf')"></b-form-feedback>
                </b-col>

                <label><b>Regra:</b></label>




             </form>
                    <div slot="modal-footer" class="w-100">
                           <div class="float-left"><spinner v-if="loading" message="Processando..."></spinner></div>
                           <div class="float-right">
                               <b-btn @click="showModalSenha=false" variant="secondary">
                                 Fechar
                               </b-btn>
                               <b-btn @click="doAlterPassword($event)" variant="primary" :disabled="isDisabled">
                                 Enviar
                               </b-btn>
                           </div>
                    </div>
                </b-modal>
                <!-- Modal Component -->
                <b-modal id="modal_form_status"
                         ref="modal_form_status"
                         :title="modal_titulo"
                         :ok-title="modal_botao"
                         close-title="Fechar"
                         cancel-title="Cancelar"
                         :ok-disabled=form.errors.any()
                         v-model="showModalStatus"
                         @ok="onStoreStatus">

               <form @submit.stop.prevent="onStoreStatus" @keydown="form.errors.clear($event.target.name)">
                   <div class="loadingDataPosition">
                       <div class="loadingData" v-if="loadingDataStatus">
                           <div class="loadingDataSpinner">
                               <spinner v-if="loadingDataStatus" text-fg-color="#ffffff" message="Carregando..."></spinner>
                           </div>
                       </div>
                       <table class="table" id="mais">
                           <thead>
                               <tr>
                                   <th style="width: 50%">Descrição</th>
                                   <th style="width: 25%">Email ?</th>
                                   <th style="width: 25%">Notificação ?</th>
                               </tr>
                            </thead>
                            <tbody>
                               <tr>
                                  <td>
                                      <b-col>
                                          <b>Relatórios</b>
                                      </b-col>
                                  </td>
                                  <td>
                                      <b-col>
                                          <b-form-checkbox buttons
                                                           button-variant="primary"
                                                           v-model="form_status.status_email_relatorio"
                                                           value="1"
                                                           unchecked-value="2">
                                          </b-form-checkbox>
                                      </b-col>
                                  </td>
                                  <td>
                                      <b-col>
                                          <b-form-checkbox buttons
                                                           button-variant="primary"
                                                           v-model="form_status.status_notif_relatorio"
                                                           value="1"
                                                           unchecked-value="2">
                                          </b-form-checkbox>
                                      </b-col>
                                  </td>
                              </tr>
                              <tr>
                                  <td>
                                      <b-col>
                                        <b>Emissão CTE</b>
                                    </b-col>
                                  </td>
                                  <td>
                                      <b-col>
                                          <b-form-checkbox buttons
                                                           button-variant="primary"
                                                           v-model="form_status.status_email_cte_emissao"
                                                           value="1"
                                                           unchecked-value="2">
                                          </b-form-checkbox>
                                      </b-col>
                                  </td>
                                  <td>
                                      <b-col>
                                          <b-form-checkbox buttons
                                                           button-variant="primary"
                                                           v-model="form_status.status_notif_cte_emissao"
                                                           value="1"
                                                           unchecked-value="2">
                                          </b-form-checkbox>
                                      </b-col>
                                  </td>
                              </tr>
                              <tr>
                                  <td>
                                      <b-col>
                                          <b>CTE Cancelamento</b>
                                      </b-col>
                                  </td>
                                  <td>
                                      <b-col>
                                          <b-form-checkbox buttons
                                                           button-variant="primary"
                                                           v-model="form_status.status_email_cte_cancelamento"
                                                           value="1"
                                                           unchecked-value="2">
                                          </b-form-checkbox>
                                      </b-col>
                                  </td>
                                  <td>
                                      <b-col>
                                          <b-form-checkbox buttons
                                                           button-variant="primary"
                                                           v-model="form_status.status_notif_cte_cancelamento"
                                                           value="1"
                                                           unchecked-value="2">
                                          </b-form-checkbox>
                                      </b-col>
                                  </td>
                              </tr>
                              <tr>
                                  <td>
                                      <b-col>
                                          <b>CTE Integrado</b>
                                      </b-col>
                                  </td>
                                  <td>
                                      <b-col>
                                          <b-form-checkbox buttons
                                                           button-variant="primary"
                                                           v-model="form_status.status_email_cte_integracao"
                                                           value="1"
                                                           unchecked-value="2">
                                          </b-form-checkbox>
                                      </b-col>
                                  </td>
                                  <td>
                                      <b-col>
                                          <b-form-checkbox buttons
                                                           button-variant="primary"
                                                           v-model="form_status.status_notif_cte_integracao"
                                                           value="1"
                                                           unchecked-value="2">
                                          </b-form-checkbox>
                                      </b-col>
                                  </td>
                              </tr>
                              <tr>
                                  <td>
                                      <b-col>
                                          <b>CTE Cancelamento Integrado</b>
                                      </b-col>
                                  </td>
                                  <td>
                                      <b-col>
                                          <b-form-checkbox buttons
                                                           button-variant="primary"
                                                           v-model="form_status.status_email_cte_integracao_canc"
                                                           value="1"
                                                           unchecked-value="2">
                                          </b-form-checkbox>
                                      </b-col>
                                  </td>
                                  <td>
                                      <b-col>
                                          <b-form-checkbox buttons
                                                           button-variant="primary"
                                                           v-model="form_status.status_notif_cte_integracao_canc"
                                                           value="1"
                                                           unchecked-value="2">
                                          </b-form-checkbox>
                                      </b-col>
                                  </td>
                              </tr>

                           </tbody>
                       </table>
                   </div>
               </form>
                      <div slot="modal-footer" class="w-100">
                             <div class="float-left"><spinner v-if="loading" message="Processando..."></spinner></div>
                             <div class="float-right">
                                 <b-btn @click="showModalStatus=false" variant="secondary">
                                   Fechar
                                 </b-btn>
                                 <b-btn @click="onStoreStatus($event)" variant="primary" :disabled="isDisabled">
                                   Enviar
                                 </b-btn>
                             </div>
                      </div>
                  </b-modal>
        </div>
    </div>
</template>
<script>
import Vuetable from '../components/Vuetable'
import VuetablePagination from '../components/VuetablePagination'
import VuetablePaginationInfo from '../components/VuetablePaginationInfo'
import moment from 'moment'

export default {
    components: {
        VuetablePagination,
        VuetablePaginationInfo,
        Vuetable
    },
    data () {
        return {
          isFullscreenTarefas: false,
          isFullscreenNotificacao: false,
          isFullscreenDownloadFile: false,
          showModal: false,
          showModalSenha: false,
          showModalStatus: false,
          loading: false,
          loadingDataStatus: true,
          isDisabled: false,
          modal_titulo: '',
          modal_botao: '',
          modal_acao: '',
          locale: 'pt_BR',
          retorno_val: '',
          optionsStatus: [],
          optionsTpTarefa: [],
          loadingDataTarefa: true,
          loadingDataNotificacao: true,
          loadingDataDownloadFile: true,
          helpForm: new Form({downloadRecord: [], cep_busca: '', params: [], statusRecord: []}),
          form: new Form({ senha_atual: '',
                           nova_senha: '',
                           nova_senha_conf: ''
                        }),
         form_tarefa: new Form({
                         titulo: '',
                          descr: '',
                          dt_cadastro: '',
                          dt_tarefa: '',
                          tp_tarefa: [],
                          status: [],
                          tarefa_id: '',
                      }),
          form_status: new Form({
                          status_email_relatorio: '',
                          status_email_cte_emissao: '',
                          status_email_cte_cancelamento: '',
                          status_email_cte_integracao: '',
                          status_email_cte_integracao_canc: '',
                          status_email_agenda: '',
                          status_notif_relatorio: '',
                          status_notif_cte_emissao: '',
                          status_notif_cte_cancelamento: '',
                          status_notif_cte_integracao: '',
                          status_notif_cte_integracao_canc: '',
                       }),
        fieldsTarefa: [
          {
            name: 'num_tarefa',
            title: 'N° Tarefa',
            sortField: 'num_tarefa'
          },
          {
            name: 'titulo',
            title: 'Título',
            sortField: 'titulo'
          },
          {
            name: 'descr',
            title: 'Descrição',
            sortField: 'descr'
          },
          {
            name: 'dt_cadastro',
            title: 'Data Cadastro',
            sortField: 'dt_cadastro',
            callback: 'formatDateHora|DD/MM/YYYY'
          },
          {
            name: 'dt_tarefa',
            title: 'Data Tarefa',
            sortField: 'dt_tarefa',
            callback: 'formatDateHora|DD/MM/YYYY'
          },
          {
            name: 'dt_execucao',
            title: 'Data Execução',
            sortField: 'dt_execucao',
            callback: 'formatDateHora|DD/MM/YYYY'
          },
          {
            name: '__slot:status',
            title: 'Status',
            sortField: 'status'
          },
          {
            name: '__slot:tp_tarefa',
            title: 'Tipo',
            sortField: 'tp_tarefa'
          },
          {
            name: '__slot:actions',
            title: 'Ações',
            titleClass: 'center aligned',
            dataClass: 'center aligned'
          }
      ],
      fieldsNotificacao: [
            {
              name: 'titulo',
              title: 'Título',
              sortField: 'titulo'
            },
            {
              name: 'descr',
              title: 'Descrição',
              sortField: 'descr'
            },
            {
              name: 'dt_hr_recebida',
              title: 'Data/Hora Recebida',
              sortField: 'dt_hr_recebida',
              callback: 'formatDateHora|DD/MM/YYYY HH:mm'
            },
            {
              name: 'param_tipo_notificacao.descr',
              title: 'Tipo',
              sortField: 'param_tipo_notificacao.descr'
            },
        ],
        fieldsDownloadFile: [
            {
              name: '__checkbox',
              titleClass: 'center aligned',
              dataClass: 'center aligned'
            },
            {
              name: 'nome',
              title: 'Relatório',
              sortField: 'nome'
            },
            {
              name: 'dt_inc',
              title: 'Data/Hora Gerado',
              sortField: 'dt_inc',
              callback: 'formatDateHora|DD/MM/YYYY HH:mm'
            },
            {
              name: '__slot:status',
              title: 'Status',
              sortField: 'status'
            },
            {
              name: '__slot:tp_relatorio',
              title: 'Tipo',
              sortField: 'tp_relatorio'
            },
            {
              name: '__slot:actions',
              title: 'Ações',
              titleClass: 'center aligned',
              dataClass: 'center aligned'
            }
        ],
      css: {
          loadingClass: 'loading',
          ascendingIcon: 'glyphicon glyphicon-chevron-up',
          descendingIcon: 'glyphicon glyphicon-chevron-down',
          handleIcon: 'glyphicon glyphicon-menu-hamburger',
      },
      moreParams: {}
       }
   },
   mounted() {
       this.getLivGeral();
     },
    methods: {
        onPaginationDataTarefa (paginationData) {
          this.$refs.paginationTarefa.setPaginationData(paginationData)
          this.$refs.paginationInfoTarefa.setPaginationData(paginationData)
        },
        onChangePageTarefa (page) {
          this.$refs.vuetable.changePage(page)
        },
        onLoadedTarefa: function () {
            this.dataExport = this.$refs.vuetable.tableData;
            this.loadingDataTarefa = false;
        },
        expandFullscreenTarefa() {
            this.isFullscreenTarefas = !this.isFullscreenTarefas;
        },
        onPaginationDataNotificacao (paginationData) {
          this.$refs.paginationNotificacao.setPaginationData(paginationData)
          this.$refs.paginationInfoNotificacao.setPaginationData(paginationData)
        },
        onChangePageNotificacao (page) {
          this.$refs.vuetable_notificacao.changePage(page)
        },
        onLoadedNotificacao: function () {
            this.dataExport = this.$refs.vuetable_notificacao.tableData;
            this.loadingDataNotificacao = false;
        },
        expandFullscreenNotificacao() {
            this.isFullscreenNotificacao = !this.isFullscreenNotificacao;
        },
        onPaginationDataDownloadFile (paginationData) {
          this.$refs.paginationDownloadFile.setPaginationData(paginationData)
          this.$refs.paginationInfoDownloadFile.setPaginationData(paginationData)
        },
        onChangePageDownloadFile (page) {
          this.$refs.vuetable_downloadfile.changePage(page)
        },
        onLoadedDownloadFile: function () {
            this.dataExport = this.$refs.vuetable_downloadfile.tableData;
            this.loadingDataDownloadFile = false;
        },
        expandFullscreenDownloadFile() {
            this.isFullscreenDownloadFile = !this.isFullscreenDownloadFile;
        },
        doAlterPassword () {
            this.loading = true;
            this.isDisabled = true;
            this.form.post('/api/usuarioconf/updatesenha').then(response =>
            {
                new ReturnApi(response, this)
            })
            .catch(errors =>
            {
                new ReturnApi(errors, this)
            });
        },
        formatDateHora (value, fmt = 'DD/MM/YYYY HH:mm') {
          return (value == null)
            ? ''
            : moment(value, 'YYYY/MM/DD HH:mm').format(fmt)
        },
        onError(response) {
            new ReturnApi(response.response, this, true, true, false);
        },
        getPermission(checkPermission) {
            return this.getPermissionFw(checkPermission);
        },
        onFilterResetDownloadFile () {
            this.loadingDataDownloadFile = true;
            this.moreParams = {}
            Vue.nextTick( () => this.$refs.vuetable_downloadfile.refresh())
        },
        onFilterResetNotificacao () {
            this.loadingDataNotificacao = true;
            this.moreParams = {}
            Vue.nextTick( () => this.$refs.vuetable_notificacao.refresh())
        },
        onFilterResetTarefa () {
            this.loadingDataTarefa = true;
            this.moreParams = {}
            Vue.nextTick( () => this.$refs.vuetable.refresh())
        },
        onVincularTarefa(data) {
            this.isDisabled = false;
            this.loading = false;
            this.modal_titulo = "Cadastrar Tarefa";
            this.modal_botao = "Cadastrar Tarefa";
            this.modal_acao = "i";
            this.form_tarefa.reset();
            this.$refs.modal_form.show();
        },
        onEditSenha(data) {
            this.isDisabled = false;
            this.loading = false;
            this.modal_titulo = "Alterar Senha";
            this.modal_botao = "Alterar Senha";
            this.modal_acao = "i";
            this.form.reset();
            this.$refs.modal_form_senha.show();
        },
        onEditStatus() {
            this.loadingDataStatus = true;
            this.isDisabled = true;
            this.helpForm.get('/api/usuarioconf/notificacao/metodos').then(response =>
            {
                new ReturnApi(response, this)
                this.form_status.status_email_relatorio = response.status_email_relatorio
                this.form_status.status_email_cte_emissao = response.status_email_cte_emissao
                this.form_status.status_email_cte_cancelamento = response.status_email_cte_cancelamento
                this.form_status.status_email_cte_integracao = response.status_email_cte_integracao
                this.form_status.status_email_cte_integracao_canc = response.status_email_cte_integracao_canc
                this.form_status.status_notif_relatorio = response.status_notif_relatorio
                this.form_status.status_notif_cte_emissao = response.status_notif_cte_emissao
                this.form_status.status_notif_cte_cancelamento = response.status_notif_cte_cancelamento
                this.form_status.status_notif_cte_integracao = response.status_notif_cte_integracao
                this.form_status.status_notif_cte_integracao_canc = response.status_notif_cte_integracao_canc
                this.loadingDataStatus = false;
            })
            .catch(errors =>
            {
                new ReturnApi(errors, this)
            });
            this.modal_titulo = "Preferências de notificação";
            this.modal_botao = "Preferências de notificação";
            this.modal_acao = "i";
            this.form.reset();
            this.$refs.modal_form_status.show();
        },
        updateTarefa(data) {
            this.isDisabled = false;
            this.loading = false;
            this.modal_titulo = "Editar Tarefa";
            this.modal_botao = "Editar Tarefa";
            this.modal_acao = "u";
            this.form_tarefa.reset();
            this.form_tarefa.titulo = data.titulo;
            this.form_tarefa.descr = data.descr;
            this.form_tarefa.dt_cadastro =  this.formatDateHora(data.dt_cadastro);
            this.form_tarefa.dt_tarefa =  this.formatDateHora(data.dt_tarefa);
            this.form_tarefa.dt_execucao =  this.formatDateHora(data.dt_execucao);
            this.form_tarefa.status = { label: data.status.descr, value: data.status.valor };
            this.form_tarefa.tp_tarefa = { label: data.tp_tarefa.descr, value: data.tp_tarefa.valor };
            this.form_tarefa.tarefa_id = data.tarefa_id;
            this.$refs.modal_form.show();
        },
        handleOk(e)
        {
            e.preventDefault();
            if(this.modal_acao=="i")
            {
               this.onStoreTarefa();
            }
            else
            {
                this.onUpdateTarefa(this.form_tarefa.tarefa_id);
            }
        },
        onStoreStatus()
        {
            this.loading = true;
            this.isDisabled = true;
            this.form_status.post('/api/usuarioconf/notificacao/metodos/update').then(response =>
            {
                new ReturnApi(response, this)
            })
            .catch(errors =>
            {
                new ReturnApi(errors, this)
            });
        },
        onStoreTarefa()
        {
            this.loading = true;
            this.isDisabled = true;
            this.form_tarefa.post('/api/usuarioconf/store/tarefa').then(response =>
            {
                new ReturnApi(response, this)
                this.onFilterResetTarefa();
            })
            .catch(errors =>
            {
                new ReturnApi(errors, this)
            });
        },
        onUpdateTarefa(id)
        {
            this.loading = true;
            this.isDisabled = true;
            this.form_tarefa.post('/api/usuarioconf/update/tarefa/'+id).then(response =>
            {
                new ReturnApi(response, this)
                this.onFilterResetTarefa();
            })
            .catch(errors =>
            {
                new ReturnApi(errors, this)
            });
        },
        onAlteraStatus(action, data, tipo)
        {

            this.helpForm.statusRecord = [];
            this.helpForm.statusRecord.push({ id: data.tarefa_id, status: action });
            this.helpForm.post('/api/usuarioconf/status').then(response =>
            {
                new ReturnApi(response, this)
                this.onFilterResetTarefa();
            })
            .catch(errors =>
            {
                new ReturnApi(errors, this)
            });

        },
        getLivGeral() {
            this.helpForm.get('/api/usuarioconf/jsonlistgeral').then(response =>
            {
                new ReturnApi(response, this, true, false, false);
                response.status.forEach((obj)=>
                {
                    this.optionsStatus.push({ label: obj.descr, value: obj.valor })
                })
                response.tp_tarefa.forEach((obj)=>
                {
                    this.optionsTpTarefa.push({ label: obj.descr, value: obj.valor })
                })
            })
            .catch(errors =>
            {
                new ReturnApi(errors, this)
            });
        },
        doDoisFatores () {
            this.loading = true;
            this.isDisabled = true;
            this.form.post('/api/usuarioconf/doisfatores').then(response =>
            {
                new ReturnApi(response, this)
            })
            .catch(errors =>
            {
                new ReturnApi(errors, this)
            });
        },
        doDoisFatoresAtivar () {
            this.loading = true;
            this.isDisabled = true;
            this.form.post('/api/usuarioconf/doisfatoresativar').then(response =>
            {
                new ReturnApi(response, this)
            })
            .catch(errors =>
            {
                new ReturnApi(errors, this)
            });
        },
        doDoisFatoresInativar () {
            this.loading = true;
            this.isDisabled = true;
            this.form.post('/api/usuarioconf/doisfatoresinativar').then(response =>
            {
                new ReturnApi(response, this)
            })
            .catch(errors =>
            {
                new ReturnApi(errors, this)
            });
        },
        onDownload(data, tipo)
        {
            // Tipo = true = Checkbox
            if(tipo)
            {
                this.helpForm.downloadRecord = [];
                this.helpForm.downloadRecord.push({ id: data.dowfil_id});
            }
            else
            {
                this.helpForm.downloadRecord = [];

                this.$refs.vuetable_downloadfile.selectedTo.forEach((obj)=>{
                    this.helpForm.downloadRecord.push({ id: obj})
                });
            }

            this.helpForm.post('/api/usuarioconf/download').then(response =>
            {
                new ReturnApi(response, this);
            })
            .catch(errors =>
            {
                new ReturnApi(errors, this);
            });

        },
    },
    computed: {
        vuetableFilterRow: {
          get () {
            return this.$store.getters.vuetable.filterRow;
          },
        },
        isLoaded: {
            get() {
                return this.$store.getters.isloaded;
            }
        }
    }
}
</script>
